import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'demo-api-key',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'demo-project.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'demo-project',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'demo-project.appspot.com',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '123456789',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:123456789:web:abcdef123456',
};

// Check if we're in production and Firebase config is missing
const isProduction = import.meta.env.PROD;
const hasFirebaseConfig = firebaseConfig.apiKey !== 'demo-api-key' && 
                         firebaseConfig.projectId !== 'demo-project';

if (isProduction && !hasFirebaseConfig) {
  console.error('Firebase configuration is missing in production. Please set environment variables in Vercel.');
  // Don't throw error to prevent app from crashing, just log warning
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);

export default app;
